import TDatePicker from './date-picker.vue'

TDatePicker.install = Vue => {
  Vue.component(TDatePicker.name, TDatePicker)
}

export default TDatePicker



// WEBPACK FOOTER //
// ./src/module/date-picker/index.js